import { PrescriptionState, ActionTypes, Action } from './types';

const INITIAL_ERROR = {
  exists: false,
  status: 0,
}

const INITIAL_STATE: PrescriptionState = {
  error: INITIAL_ERROR,
  loading: true,
  prescription: {
    id: 0,
    token: '',
    sent_via: '',
    signed: false,
    prescription_date: null,
    created_at: '',
    config: { show_date: false },
    doctor: {
      id: 0,
      abbreviation: '',
      name: '',
      city: '',
      regional_code: '',
      board_number: '',
      uf: '',
    },
    document: {
      url: '',
    },
    patient: {
      name: '',
    },
    items: [],
  },
  dispensation: {
    errors: [],
    loading: false,
  },
  permissions: {
    user: {
      id: 0,
      name: '',
      first_name: '',
      last_name: '',
      email: '',
    },
    allowed_drugstores: [],
  },
  mustUpdateHistory: false,
};

export default function reducer(state = INITIAL_STATE, action: Action): PrescriptionState {
  switch (action.type) {
    case ActionTypes.FETCH:
      return {
        ...state,
        error: INITIAL_ERROR,
        loading: true,
        mustUpdateHistory: false,
      };

    case ActionTypes.FETCH_SUCCESS:
      return {
        ...state,
        error: INITIAL_ERROR,
        loading: false,
        prescription: action.prescription,
        mustUpdateHistory: true,
        dispensation: {
          errors: [],
          loading: false,
        },
      };

    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
        error: {
          exists: true,
          status: action.status,
        },
        loading: false,
        mustUpdateHistory: false,
      };

    case ActionTypes.DISPENSE:
      return {
        ...state,
        dispensation: {
          errors: [],
          loading: true,
        },
        mustUpdateHistory: false,
      };

    case ActionTypes.DISPENSE_SUCCESS:
      return {
        ...state,
        dispensation: {
          errors: [],
          loading: false,
        },
        prescription: action.prescription,
        mustUpdateHistory: true,
      };

    case ActionTypes.DISPENSE_ERROR:
      return {
        ...state,
        dispensation: {
          errors: action.errors,
          loading: false,
        },
        mustUpdateHistory: false,
      };

    case ActionTypes.DISPENSE_CANCEL:
      return {
        ...state,
        mustUpdateHistory: false,
      };

    case ActionTypes.DISPENSE_CANCEL_SUCCESS:
      return {
        ...state,
        prescription: action.prescription,
        mustUpdateHistory: true,
      };

    case ActionTypes.UPDATE_ITEMS:
      return {
        ...state,
        prescription: {
          ...state.prescription,
          items: action.items,
        },
      };

    case ActionTypes.SET_UNLOCK_DATA:
      return {
        ...state,
        prescription: {
          ...state.prescription,
          doctor: {
            ...state.prescription.doctor,
            ...action.payload.doctor,
          },
          patient: {
            ...state.prescription.patient,
            ...action.payload.patient,
          },
        },
      };

    default:
      return state;
  }
}
